import { Company } from '@/service/ts-definitions';
export const lowPrioritySizes: Record<Company['name'], string[]> = {
  a4: ['N/A', 'Null'],
};
